module.exports = __webpack_public_path__ + "img/vertical_4_3_9016.04bc0e58.png";